import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelCTerm } from "../../types/levelc-reports";

export const useGetLevelCTerms = (startDate?: string, endDate?: string) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchTerms = async (): Promise<LevelCTerm[]> => {
        try {
            const params = new URLSearchParams();
            
            if (startDate) {
                params.append('startDate', startDate);
            }
            if (endDate) {
                params.append('endDate', endDate);
            }

            const url = params.toString() 
                ? `/api/levelcreports/terms?${params.toString()}`
                : '/api/levelcreports/terms';
            
            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            throw new Error(t("levelCReports.errors.getTerms"));
        }
    };

    return useQuery({
        queryKey: ["levelCTerms", startDate, endDate],
        queryFn: fetchTerms,
    });
};

